import { Record } from 'immutable';

import { resolve } from '../helpers/LinkMapper';


const TOC = new Record({
    id: null,
    code: null,
    name: null
});

TOC.fromJSON = function (json) {
    json = json || {};

    const code = resolve(json.code).with(String);
    const name = resolve(json.name).with(String);
    const id = json.id;

    let result = { id, code, name };

    return new TOC(result);
};

export default TOC;
